import React from 'react';
import classes from './ColorBulletListItem.module.scss';

interface ColorBulletListItemProps {
  color: string;
  children?: React.ReactNode;
  className?: string;
}

const ColorBulletListItem = (props: ColorBulletListItemProps): JSX.Element => {
  const { color, children, className = '' } = props;
  return (
    <li className={`${classes.item} ${className}`}>
      <div
        className={classes.bullet}
        style={{
          backgroundColor: color,
        }}
        aria-hidden="true"
      />
      <div>{children}</div>
    </li>
  );
};

export default ColorBulletListItem;
